import { render, staticRenderFns } from "./TopLeague.vue?vue&type=template&id=3be31151&"
import script from "./TopLeague.vue?vue&type=script&lang=js&"
export * from "./TopLeague.vue?vue&type=script&lang=js&"
import style0 from "./TopLeague.vue?vue&type=style&index=0&id=3be31151&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports